import React, { useState, useEffect } from "react";
import {
  BOOK_DETAILS_DESCRIPTION_HEADING,
  BOOK_DETAILS_DESCRIPTION_FAQ_HEADING,
} from "../../constants/text_constants";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../components/ui/accordion";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import userLogout from "../../utils/userLogout";
import { useSelector } from "react-redux";

const BookDescriptionTab = ({ bookId, description }) => {
  const [bookFAQ, setBookFAQ] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isSideBarOpen = useSelector((store) => store.sidebar.isSideBarOpen);

  const fetchBookFAQs = async (retries = 6) => {
    try {
      const authToken =
        sessionStorage.getItem("token") || process.env.REACT_APP_TEMP_TOKEN;
      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };
      const response = await fetch(
        process.env.REACT_APP_RANK_PLUS_COURSE_DETAILS_FAQ +
        `limit=20&page=0&type=book&id=${bookId}`,
        requestOptions
      );
      if (!response.ok) {
        if (response.status >= 400 && response.status < 500) {
          userLogout(navigate, dispatch, true);
        }
        if (response.status >= 500 && response.status < 600 && retries > 0) {
          console.warn(`Retrying... attempts left: ${retries}`);
          setTimeout(() => fetchBookFAQs(retries - 1), 10000);
          return;
        } else {
          throw new Error(`HTTP error: ${response.status}`);
        }
      }
      const json = await response.json();
      setBookFAQ(json?.data?.faqs);
    } catch (err) {
      console.error("Error fetchBookFAQs", err);
    }
  };

  useEffect(() => {
    fetchBookFAQs();
  }, [bookId]);

  return (
    <div className="w-full md:w-[40%] lg:w-[100%]">
      <div className="text-2xl font-semibold my-1">
        {BOOK_DETAILS_DESCRIPTION_HEADING}
      </div>
      <div
        className={
          "description-content space-y-2 md:text-[1rem] text-sm w-full max-w-full leading-7 " +
          (isSideBarOpen ? "w-[48rem]" : "w-full")
        }
        dangerouslySetInnerHTML={{ __html: description }}
      />
      <div className="text-2xl font-bold mt-1 mb-2">
        {BOOK_DETAILS_DESCRIPTION_FAQ_HEADING}
      </div>
      <div>
        {bookFAQ?.map((ele, i) => (
          <div key={i}>
            <Accordion type="single" collapsible>
              <AccordionItem value={`item-${i}`}>
                <AccordionTrigger className="md:text-[1rem] text-sm text-left">
                  {ele?.question}
                </AccordionTrigger>
                <AccordionContent className="md:text-[1rem] text-sm text-left">
                  <div className="max-h-[500px] overflow-y-auto pr-2 block">
                    {ele?.answer}
                  </div>
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BookDescriptionTab;
